import { useCallback, useEffect, useRef, useState } from "react";
import {
  acknowledgeMaintenanceNotice,
  shouldShowMaintenanceNotice,
} from "./maintenance-notice-state";
import "./maintenance-notice.css";

export function MaintenanceNotice() {
  const [visible, setVisible] = useState(() =>
    shouldShowMaintenanceNotice(new Date(), window.localStorage));
  const confirmationRef = useRef<HTMLButtonElement>(null);

  const close = useCallback(() => {
    acknowledgeMaintenanceNotice(window.localStorage);
    setVisible(false);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const previousFocus = document.activeElement instanceof HTMLElement
      ? document.activeElement : null;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    confirmationRef.current?.focus();
    const closeWithEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") close();
    };
    window.addEventListener("keydown", closeWithEscape);
    return () => {
      window.removeEventListener("keydown", closeWithEscape);
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, [close, visible]);

  if (!visible) return null;
  return (
    <div className="maintenance-notice-backdrop">
      <section
        className="maintenance-notice-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="maintenance-notice-title"
        aria-describedby="maintenance-notice-description"
      >
        <button
          type="button"
          className="maintenance-notice-close"
          aria-label="告知を閉じる"
          onClick={close}
        >×</button>
        <p className="maintenance-notice-eyebrow">SERVICE NOTICE</p>
        <h2 id="maintenance-notice-title">8月13日（木）のメンテナンスについて</h2>
        <p id="maintenance-notice-description">
          8月13日（木）はメンテナンスのため、サービスが停止する可能性があります。
          大事なデモを予定している方は、朝長までご連絡ください。
        </p>
        <button
          ref={confirmationRef}
          type="button"
          className="maintenance-notice-confirm"
          onClick={close}
        >確認しました</button>
      </section>
    </div>
  );
}
